'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Connect = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.0896 15.4923C36.564 15.0533 35.887 14.8385 35.2047 14.8943C34.5223 14.95 33.8891 15.2718 33.4416 15.7903L28.936 21.0617H27.808C27.928 20.7669 27.9989 20.4448 27.9989 20.1074C27.9989 18.6946 26.8349 17.5384 25.4113 17.5384H15.0583C12.2154 17.5384 10.7306 19.0123 10.7306 19.0123L7.50586 21.9166L13.6576 28.3169H28.8051L28.7931 28.2623C29.3775 28.1613 29.909 27.8612 30.2975 27.4128L37.3885 19.1117C37.6073 18.8548 37.7732 18.5572 37.8766 18.236C37.9801 17.9147 38.019 17.5761 37.9913 17.2398C37.9635 16.9034 37.8695 16.5758 37.7148 16.2759C37.56 15.976 37.3476 15.7097 37.0896 15.4923Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.7153 17.5386H26.9235C28.3472 17.5386 29.5112 18.6959 29.5112 20.1066C29.5112 21.5194 28.3472 22.6756 26.9235 22.6756H20.0234",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M15.7153 17.5386H26.9235C28.3472 17.5386 29.5112 18.6959 29.5112 20.1066C29.5112 21.5194 28.3472 22.6756 26.9235 22.6756H20.0234",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.7121 33.6985L2.27598 24.9879C2.18595 24.8947 2.11524 24.7846 2.06791 24.664C2.02058 24.5433 1.99757 24.4145 2.0002 24.2849C2.00284 24.1553 2.03107 24.0275 2.08327 23.9088C2.13547 23.7902 2.2106 23.6831 2.30435 23.5936L5.07203 20.9536C5.26324 20.7728 5.51772 20.6744 5.78071 20.6795C6.0437 20.6846 6.29417 20.7928 6.47823 20.9809L14.9133 29.6915C15.0034 29.7846 15.0742 29.8947 15.1216 30.0153C15.169 30.1359 15.1921 30.2647 15.1896 30.3943C15.1871 30.5239 15.1589 30.6517 15.1068 30.7704C15.0547 30.8891 14.9797 30.9962 14.886 31.0858L12.1172 33.7258C11.9262 33.9065 11.6719 34.0049 11.4091 33.9998C11.1463 33.9947 10.896 33.8865 10.7121 33.6985Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22.2085 13.5H24.8536C26.8597 13.5 28.5 11.8125 28.5 9.74911C28.5 7.68746 26.8597 6 24.8545 6H22.1407M18.7906 6H16.1455C14.1403 6 12.5 7.68746 12.5 9.75C12.5 11.8125 14.1403 13.5 16.1455 13.5H18.8593",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M17.457 9.75H23.5432",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M5.45166 24.0958L6.81532 25.4606",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = Connect;
